<div class="progreso-container" *ngIf="visible">
    <neo-icono data-testid="icono-completado" *ngIf="completado; else progresoCarga" [iconoClase]="'icon-32 icon-ibm--checkmark--filled text-success' "></neo-icono>
    <ng-template #progresoCarga>
        <neo-circulo-progreso #progresoComponente class="circulo-progreso"
                            [identificador]="identificador"
        ></neo-circulo-progreso>
    </ng-template>
</div>
